const textAnim = document.querySelector('.j-text-animation');

const removeClass = (): void => {
    if (!textAnim) {
        return;
    }

    textAnim.classList.remove('is-full-width');
};

const addClass = (): void => {
    if (!textAnim) {
        return;
    }

    textAnim.classList.add('is-full-width');
};

if (textAnim) {
    if ('IntersectionObserver' in window) {
        const textObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry: IntersectionObserverEntry) => {
                if (entry.isIntersecting) {
                    if (textAnim.classList.contains('is-full-width')) {
                        removeClass();
                    }
                } else if (!textAnim.classList.contains('is-full-width')) {
                    addClass();
                }
            });
        });

        textObserver.observe(textAnim);
    } else {
        removeClass();
    }
}
